import { differenceInHours } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { utcToZonedTime } from "date-fns-tz";

/**
 * Calculates the difference in hours between two timezones.
 * A positive result means tz1 is ahead of tz2, negative means behind.
 */
export function getTimezoneDifferenceInHours(tz1: string, tz2: string): number {
  const now = new Date();
  const timeInTZ1 = utcToZonedTime(now, tz1);
  const timeInTZ2 = utcToZonedTime(now, tz2);
  return differenceInHours(timeInTZ1, timeInTZ2);
}
